import styled from "styled-components";

const Line = styled.div<{ $horizontal: boolean; $length: number }>`
  ${(p) =>
    p.$horizontal
      ? `
    width: ${p.$length}px;
    height: 1px;
  `
      : `
    width: 1px;
    height: ${p.$length}px;
  `}
  background-color: ${(p) => p.theme.colors.mediumBorderGrey};
`;

export default Line;
